import { render } from "./PageBody.vue?vue&type=template&id=cbf4439e&scoped=true"
import script from "./PageBody.vue?vue&type=script&lang=js"
export * from "./PageBody.vue?vue&type=script&lang=js"

import "./PageBody.vue?vue&type=style&index=0&id=cbf4439e&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbf4439e"]])

export default __exports__